// initializing 
(function() {
    if(window.location.href.indexOf("rewards")>-1) {
      $('.account-nav li.active').removeClass('active');
      $('.account-nav li.is-active').removeClass('is-active');
      $(".menu-item-1245673").addClass("is-active");
      $(".menu-item-1245673").addClass("active");
    }
    var swell_loader_flag = true;
    
    $(document).on("swell:setup", function() {
      if(swell_loader_flag) {
        swell_loader_flag = false;
        if((window.location.href.indexOf("cart")>-1) || (window.location.href.indexOf("checkout")>-1) ) {
          Swell.Checkout.widgetEl.detach().show().insertBefore(Swell.Checkout.selectors.target); 
        }
        if($(".swell-campaign-list").length > 0) {
          Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);      
          if(spapi.authenticated) {
            SwellConfig.Campaign.addCursorPointerForCampaigns();
          }
          SwellConfig.Campaign.hideCampaigns();
        }

        if($(".swell-referral").length > 0) {
         Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
         
         if(window.location.href.indexOf("order-received")>-1) {
          $(".thankyou-popup").css("display", "flex");
         }

         if($(".swell-referral-table").length > 0) {
          setupReferrals();
         }
        }

        if($(".big-spinner").length > 0) {
          $(".big-spinner").hide();
        }

        if($(".swell-tier-table").length > 0) {
          if(spapi.activeVipTiers.length==0) {
            spapi.activeVipTiers = [{
              amount_spent_cents:15000,
              id:955,
              name:"Best Friends",
              points_multiplier:"1.5",
              prettyAmountSpent:"$150",
              rank:0
            },
            {
              amount_spent_cents:30000,
              id:956,
              name:"Forever Friends",
              points_multiplier:"2.0",
              prettyAmountSpent:"$300",
              rank:1           
            }];
          }

          SwellConfig.Tier.initializeDummyTier();
          SwellConfig.Tier.initializeCustomTierProperties();
          SwellConfig.Tier.initializeTiers(".swell-tier-table");
        }

        function setupReferrals () {
          if(spapi.authenticated) {
            if(spapi.customer.referral_receipts.length > 0) {
              $(".referral-table").show();

              referrals = spapi.customer.referral_receipts;

              referrals.forEach(function(referral) {
                status = null;

                if(referral.completed_at){ 
                  status = "Purchased("+spapi.activeReferralCampaign.prettyReward+" earned)";
                } else {
                  status = "Invited";
                }

                $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
              });  
            }
          }
        }

        $(".swell-referral-back-link").click(function(e) {
          $(".thankyou-popup").hide();  
        });

        $( 'body' ).on('click',"#swell-referral-refer-submit", function() {
          setTimeout(function() {
            if($(".swell-referral-thanks").length > 0){
              swellAPI.refreshCustomerDetails(function(){
                var customerDetails = swellAPI.getCustomerDetails();
                referrals = customerDetails.referrals;

                $(".swell-referral-table tbody").html("");

                referrals.forEach(function(referral) {
                  status = null;

                  if(referral.completed_at){ 
                    status = "Purchased("+spapi.activeReferralCampaign.prettyReward+" earned)";
                  } else {
                    status = "Invited";
                  }

                  $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
                });
              });
            }
          }, 1500);
        });
      }
    });

    triggerSwellSetupEvent(3000);
    function triggerSwellSetupEvent(timeout) {
      setTimeout(function() {
        if(typeof spapi !== 'undefined') {
          if(swell_loader_flag) {
            spapi.triggerEvent("swell:setup");
          }
        } else {
          triggerSwellSetupEvent(1000);
        }
      }, timeout);
    }

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      var errorMessage = "Oops! Looks like this person has already made a purchase. Try referring another friend.";
      if (!(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")) {
        errorMessage = textStatus;
      }
      $(".swell-referral-error").text(errorMessage);
    });
}).call(this);


// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign swell-campaign-login'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='fa <%= campaign.icon %>'></i> </span> </div> <div class='swell-campaign-type'> <span class='swell-campaign-type-content'><%= campaign.title %></span> <div class='swell-campaign-value'> <span class='swell-campaign-value-content'><%= campaign.reward_text %></span> </div> </div> </div> </li>"
      }
    },
    addCursorPointerForCampaigns: function() {
      $(".swell-campaign-content").css("cursor", "pointer");
    },
    hideCampaigns: function() {
      if(spapi.customer.vip_tier == undefined) {
        $(".swell-campaign-content[data-campaign-id='423934']").parent().remove();
        $(".swell-campaign-content[data-campaign-id='423936']").parent().remove();
      } else { 
         if(spapi.customer.vip_tier.name == "Best Friends") {
          $(".swell-campaign-content[data-campaign-id='423929']").parent().remove();
          $(".swell-campaign-content[data-campaign-id='423936']").parent().remove();
         } 
         if(spapi.customer.vip_tier.name == "Forever Friends") {
          $(".swell-campaign-content[data-campaign-id='423929']").parent().remove();
          $(".swell-campaign-content[data-campaign-id='423934']").parent().remove();
         }
      }
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "Refer a friend",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralRegisterFormDetails: "Please submit your email below to register!",
        referralRegisterFormEmail: "your email",
        referralRegisterFormSubmit: "Next",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
        referralReferFormEmails: "your friends emails (separated by commas)",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Twitter",
        referralShareCopy: "Copy Link",

        referralFacebookIcon: "fa fa-facebook",
        referralTwitterIcon: "fa fa-twitter",
        referralLinkIcon: "fa fa-link",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "Copy Link",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates: {
        referralRefer: "<div class='swell-referral-refer'> <h3>Refer a friend</h3> <h2 class='swell-referral-heading'><%= localization.referralReferHeading %></h2> <p class='swell-referral-details'><%= localization.referralReferDetails %></p> <div class='swell-referral-form-wrapper'> <form class='swell-referral-form' name='swell-referral-refer-form' id='swell-referral-refer-form' method='POST' action='.'> <div class='swell-referral-form-header'> <p class='swell-referral-form-header-details'><%= localization.referralReferFormDetails %></p> </div> <div class='swell-referral-form-body'> <ul class='swell-referral-form-list'> <p class='swell-referral-error'></p> <li class='swell-referral-form-list-field'>  <input class='swell-referral-form-list-field-input' type='text' name='swell-referral-refer-emails' id='swell-referral-refer-emails' required='required' placeholder='<%= localization.referralReferFormEmails %>'> <input class='swell-referral-form-list-submit' type='submit' name='swell-referral-refer-submit' id='swell-referral-refer-submit' value='<%= localization.referralReferFormSubmit %>'> <span class='swell-referral-form-field-details'><%= localization.referralReferFormEmailsDetails %></span> </li> </ul> </div> </form> </div> <div class='swell-referral-media-wrapper'> <p class='swell-referral-media-details'><%= localization.referralReferMediaDetails %></p> <ul class='swell-referral-media-list'> <li class='swell-referral-medium swell-share-referral-facebook'> <div class='swell-referral-medium-content'> <i class='swell-referral-media-icon <%= localization.referralFacebookIcon %>' aria-hidden='true'></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class='swell-referral-medium swell-share-referral-twitter'> <div class='swell-referral-medium-content'> <i class='swell-referral-media-icon <%= localization.referralTwitterIcon %>' aria-hidden='true'></i>&nbsp;<%= localization.referralShareTwitter %> </div> </li> <li class='swell-referral-medium swell-share-referral-copy'> <div class='swell-referral-medium-content'> <i class='swell-referral-media-icon <%= localization.referralLinkIcon %>' aria-hidden='true'></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>",
        referralRegister: "<div class='swell-referral-register'> <h3>Refer a friend</h3>  <h2 class='swell-referral-heading'><%= localization.referralRegisterHeading %></h2> <p class='swell-referral-details'><%= localization.referralRegisterDetails %></p> <div class='swell-referral-form-wrapper'> <form name='swell-referral-register-form' id='swell-referral-register-form' method='POST' action='.'> <div class='swell-referral-form-header'> <p class='swell-referral-form-header-details'><%= localization.referralRegisterFormDetails %></p> </div> <div class='swell-referral-form-body'> <ul class='swell-referral-form-list'> <li class='swell-referral-form-list-field'> <input class='swell-referral-form-list-field-input' type='email' name='swell-referral-register-email' id='swell-referral-register-email' required='required' placeholder='<%= localization.referralRegisterFormEmail %>'> <input class='swell-referral-form-list-submit' type='submit' name='swell-referral-register-submit' id='swell-referral-register-submit' value='<%= localization.referralRegisterFormSubmit %>'> </li> </ul> </div> </form> </div> </div>"
      } 
    }
  };
}).call(this);

//Tier
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var customer_tier_id, customer_tier_rank, next_tier, column_length;
      
      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      
      
      if(customer_tier_id == null) {
        next_tier = SwellConfig.Tier.getTierByRank(1);
      }
      else {
        next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      }
      
      column_length = $(".swell-tier-table tbody tr:eq(0)").children().length
      $(".swell-tier-table thead").prepend("<tr class='tier-status'> <th scope='row'></th> <th></th> <th></th> <th></th> </tr>");
      
      
      if(customer_tier_id == spapi.activeVipTiers[spapi.activeVipTiers.length-1].id) {
        $(".swell-tier-table .tier-status th:nth-child("+column_length+")").prepend("<span class='current-status'>Current Tier</span>");
      } 
      else {
        for(counter = 1; counter <= column_length ; counter++) {
          data_id = $(".swell-tier-table tbody tr:eq(0) td:eq("+counter+")").data("tier-id");
          if(data_id == customer_tier_id) {
            counter = counter + 1;
            $(".swell-tier-table .tier-status th:eq("+counter+")").prepend("<span class='current-status'>Current Tier</span>");
            $(".swell-tier-table .tier-status th:eq("+(counter+1)+")").prepend("<span class='next-status'>Spend $"+ ((next_tier.amount_spent_cents - swellAPI.getCustomerDetails().vipTierStats.amountSpentCents) / 100) + " more for " + next_tier.name + "</span>");
          }
        }
      }
      
      if(customer_tier_id == null) {
        $(".swell-tier-table .tier-status th:eq(1)").prepend("<span class='current-status'>Current Tier</span>");
        $(".swell-tier-table .tier-status th:eq(2)").prepend("<span class='next-status'>Spend $"+((next_tier.amount_spent_cents) / 100) + " for " + next_tier.name + "</span>");
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Friends",
        points: "$0&ndash;$149",
        dog_birthday_points: "100",
        points_multiplier: "1X",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {      
      var upperRange =  spapi.activeVipTiers[2].amount_spent_cents/100 - 1;
      
      spapi.activeVipTiers[1].points_multiplier = spapi.activeVipTiers[1].points_multiplier+"X"
      spapi.activeVipTiers[1].dog_birthday_points = "200";
      spapi.activeVipTiers[1].points = spapi.activeVipTiers[1].prettyAmountSpent + "-$" + upperRange;
      
      spapi.activeVipTiers[2].points_multiplier = spapi.activeVipTiers[2].points_multiplier+"X"
      spapi.activeVipTiers[2].points = spapi.activeVipTiers[2].prettyAmountSpent + "+";
      return spapi.activeVipTiers[2].dog_birthday_points = "300";
    },
    initializeTiers: function(containerSelector) {
      var i, j, k , key, properties, property, ref, ref1, tiers;
      if ($(containerSelector).length === 0) {
        return;
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          points_multiplier: {
            title: "Multiplier"
          },
          dog_birthday_points: {
            title: "Dog's Birthday Points"
          }
        }
      };
      $(containerSelector).append("<tbody></tbody>");
      
      k=1;
      tiers.forEach(function(tier) {        
        $(containerSelector).find("thead .swell-tier-values th:eq(" + k + ") .text-holder").append(tier.points);
        $(containerSelector).find("thead .swell-tier-names th:eq(" + k + ")").text(tier.name);
        k++;
      });
       
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr>\n  <th scope=\"row\">" + property.title + "</th>\n</tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id=\"" + tier.id + "\">" + tier[key] + "</td>");
        });
        i++;
      }

      
      if (spapi.authenticated) {
        return SwellConfig.Tier.setupCustomerTierStatus();
      }
    }
  };
}).call(this);

// faqs initializer
(function() {
  var classNames, selectors;

  classNames = {
    container: "swell-question-content",
    heading: "swell-question-heading",
    section: "swell-question-details",
    open: "swell-question-open"
  };

  selectors = {
    container: "." + classNames.container,
    heading: "." + classNames.heading,
    section: "." + classNames.section,
    open: "." + classNames.open
  };

  $(document).ready(function() {
    var heading, toHide;
    $(selectors.container).css("overflow", "hidden");
    toHide = $(selectors.container).not(selectors.open).find(selectors.section);
    heading = $(selectors.heading);
    toHide.hide();
    heading.css("cursor", "pointer");
    heading.click(function() {
      var parent, t;
      t = $(this);
      parent = t.parent();
      if (parent.hasClass(classNames.open)) {
        parent.removeClass(classNames.open);
        t.attr("aria-expanded", "false");
        t.find( '.faq-arrow' ).removeClass("fa-angle-down");
        t.find( '.faq-arrow' ).addClass("fa-angle-right");
      } else {
        parent.addClass(classNames.open);
        t.attr("aria-expanded", "true");
        t.find( '.faq-arrow' ).removeClass("fa-angle-right");
        t.find( '.faq-arrow' ).addClass("fa-angle-down");
      }
      t.next().slideToggle("fast");
      return false;
    });
  });
}).call(this);
